module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('fiscalYearDialog', {
    ref: "fyDialog"
  }), _vm._v(" "), _c('fiscalyearList', {
    on: {
      "delete-message": _vm.deleteMessage,
      "edit-fiscalYear": _vm.editFiscalYear
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17591147"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/settings/fiscalYear.vue
// module id = 2059
// module chunks = 0